import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { filterRequest } from "../../utilities/apiManager";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getTechExpenses = createAsyncThunk(
  "techExpenses/getTechExpenses",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/tech_expenses?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createTechExpense = createAsyncThunk(
  "techExpenses/createTechExpense",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/tech_expenses`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateTechExpense = createAsyncThunk(
  "techExpenses/updateTechExpense",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/tech_expenses/${args._id}`,
        args.values,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteTechExpense = createAsyncThunk(
  "techExpenses/deleteTechExpense",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/tech_expenses/${args._id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const techExpensesSlice = createSlice({
  name: "techExpenses",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getTechExpenses.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getTechExpenses.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getTechExpenses.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createTechExpense.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createTechExpense.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createTechExpense.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateTechExpense.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateTechExpense.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateTechExpense.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteTechExpense.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteTechExpense.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteTechExpense.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default techExpensesSlice.reducer;